import { useTranslation } from 'react-i18next';

import { Button } from 'src/components/Buttons/Button';

type RecurringEventScopeChoiceProps = {
    action: 'edit' | 'delete' | 'cancel';
    busy?: boolean;
    onCancel: () => void;
    onOccurrence: () => void;
    onSeries: () => void;
};

export const RecurringEventScopeChoice = ({
    action,
    busy = false,
    onCancel,
    onOccurrence,
    onSeries,
}: RecurringEventScopeChoiceProps) => {
    const { t } = useTranslation();
    const isDelete = action === 'delete';
    const isCancelEvent = action === 'cancel';
    const promptKey = isDelete
        ? 'modules.calendar.form.deleteRecurringPrompt'
        : isCancelEvent
        ? 'modules.calendar.form.cancelRecurringPrompt'
        : 'modules.calendar.form.editRecurringPrompt';

    return (
        <div className="flex min-h-0 flex-1 flex-col overflow-hidden">
            <div className="flex flex-1 items-center justify-center overflow-y-auto px-5 py-8 sm:px-8 sm:py-10">
                <div className="w-full max-w-lg rounded-2xl bg-white bg-opacity-50 p-5 sm:p-6">
                    <p>{t(promptKey)}</p>
                </div>
            </div>
            <footer className="flex flex-shrink-0 flex-wrap justify-end gap-3 border-t border-woodyBrown/15 bg-lightPeach px-5 py-4 sm:px-8">
                <Button
                    title={t('common.cancel')}
                    size="comfortable"
                    onClick={onCancel}
                    disabled={busy}
                />
                <Button
                    title={t(
                        isDelete
                            ? 'modules.calendar.form.deleteThisEvent'
                            : isCancelEvent
                            ? 'modules.calendar.form.cancelThisEvent'
                            : 'modules.calendar.form.thisEvent',
                    )}
                    size="comfortable"
                    onClick={onOccurrence}
                    disabled={busy}
                    active
                />
                <Button
                    title={t(
                        isDelete
                            ? 'modules.calendar.form.deleteAllEvents'
                            : isCancelEvent
                            ? 'modules.calendar.form.cancelAllEvents'
                            : 'modules.calendar.form.allEvents',
                    )}
                    size="comfortable"
                    onClick={onSeries}
                    disabled={busy}
                />
            </footer>
        </div>
    );
};
